export default function WhyUsSection() {
  return (
    <section id="why-us" className="py-24 bg-gradient-to-br from-emerald-600 to-emerald-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
            <span className="text-sm font-semibold text-white">Perché Sceglierci</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Il Partner Ideale per il Tuo Progetto
          </h2>
          <p className="text-lg text-emerald-100 max-w-3xl mx-auto">
            GLOBAL ENERGY SRL è riconosciuta come un interlocutore solido e competente nel settore del <strong>risparmio energetico</strong> ad Arezzo
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-2xl mb-6 mx-auto">
              <i className="ri-time-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-white mb-2">10+</h3>
            <p className="text-sm text-emerald-100">Anni di Esperienza nel Settore</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-2xl mb-6 mx-auto">
              <i className="ri-team-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-white mb-2">500+</h3>
            <p className="text-sm text-emerald-100">Clienti Soddisfatti</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-2xl mb-6 mx-auto">
              <i className="ri-checkbox-circle-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-white mb-2">1000+</h3>
            <p className="text-sm text-emerald-100">Progetti Completati</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-2xl mb-6 mx-auto">
              <i className="ri-award-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-white mb-2">100%</h3>
            <p className="text-sm text-emerald-100">Qualità Garantita</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl mb-6">
              <i className="ri-shield-check-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Esperienza e Affidabilità</h3>
            <p className="text-sm text-emerald-100 leading-relaxed">
              Oltre un decennio di operatività nel <strong>risparmio energetico</strong> con know-how consolidato e rapporti duraturi con clienti e partner
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl mb-6">
              <i className="ri-medal-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Qualità dei Materiali</h3>
            <p className="text-sm text-emerald-100 leading-relaxed">
              Utilizziamo solo materiali certificati e conformi alle normative di settore per garantire prestazioni ottimali
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl mb-6">
              <i className="ri-customer-service-2-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Supporto Dedicato</h3>
            <p className="text-sm text-emerald-100 leading-relaxed">
              Assistenza tecnica qualificata in ogni fase del progetto, dalla progettazione alla manutenzione
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl mb-6">
              <i className="ri-lightbulb-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Innovazione</h3>
            <p className="text-sm text-emerald-100 leading-relaxed">
              Investiamo costantemente in innovazione e sostenibilità per offrire soluzioni all'avanguardia
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl mb-6">
              <i className="ri-map-pin-2-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Presenza sul Mercato</h3>
            <p className="text-sm text-emerald-100 leading-relaxed">
              Forte presenza sul mercato italiano con portafoglio clienti diversificato e posizione consolidata
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl mb-6">
              <i className="ri-line-chart-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Visione Strategica</h3>
            <p className="text-sm text-emerald-100 leading-relaxed">
              Orientati al rafforzamento della presenza nazionale e all'ampliamento dell'offerta di soluzioni
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
